import Vue from 'vue';
export default Vue.extend({
    props: {
        gutters: {
            type: Boolean,
            default: true,
        },
        hAlign: {
            type: String,
            default: null
        },
        vAlign: {
            type: String,
            default: null
        },
    },
    // @ts-ignore
    getClassMap: function (props, boundClass) {
        var classMap = {
            'no-gutters': !props.gutters,
            'justify-content-start': props.hAlign == 'left',
            'justify-content-end': props.hAlign == 'right',
            'justify-content-center': props.hAlign == 'center',
            'justify-content-between': props.hAlign == 'spread',
            'justify-content-around': props.hAlign == 'around',
            'align-items-start': props.vAlign == 'top',
            'align-items-end': props.vAlign == 'bottom',
            'align-items-center': props.vAlign == 'center'
        };
        return classMap;
    }
});
